<template>
  <div class="business-layout">
    <section v-show="!loading">
      <router-view :loading="loading"></router-view>
    </section>
    <Loading v-if="loading" />
  </div>
</template>

<script>
import Loading from '@components/OfficialAccount/Loading.vue'
import { localStorage } from '@utils/basicUtil'
import { officialAccountRequest } from '@services'

export default {
  data: () => ({
    title: '',
    timer: null
  }),
  computed: {
    loading () {
      return this.$store.state.officialAccount.loading
    }
  },
  mounted () {
    this.closeLoading()
    this.historyOnChange()
    this.checkLogin()
    this.weixin()
  },
  methods: {
    historyOnChange (item) {
      if (item) {
        this.title = item.title || ''
      }
    },
    closeLoading () {
      this.timer = null
      this.timer = setTimeout(() => {
        this.$store.commit('officialAccount/changeLoading', false)
      }, 2000)
    },
    checkLogin () {
      if (localStorage.get('login')) {
        this.$store.commit('officialAccount/changeUserInfo', JSON.parse(localStorage.get('user')))
        this.getToken()
      } else {
        this.$router.push('/official-account/login')
      }
    },
    async getToken () {
      const data = await officialAccountRequest.weChat.freeAccountLogin()

      if (data.success) {
        if (!data.result) return
        localStorage.set('X-Access-Token', data.result)
      }
    },
    async weixin () {
      let wx = require('weixin-js-sdk')
      window.wx = wx
      const data = await officialAccountRequest.weChat.getOffiaccountSignature({ url: encodeURIComponent(window.location.href.split('#')[0]) })

      if (data.success) {
        wx.config({
          debug: false,
          appId: 'wx2e83ede6d42145ca',
          timestamp: data.result.timestamp,
          nonceStr: data.result.nonceStr,
          signature: data.result.signature,
          jsApiList: [
            'chooseImage',
            'getLocalImgData'
          ]
        })
        // 处理验证失败的信息
        wx.error(function (res) {
          console.log('验证失败返回的信息:', res)
        })
        wx.ready(function (res) {
        })
      }
    }
  },
  components: {
    Loading
  }
}
</script>

<style lang="less" scoped>
  .business-layout {
    position: relative;
    overflow: hidden;
    height: 100%;
    width: 100%;
    overflow-y: auto;
    background: #EDF2F6;
    -webkit-overflow-scrolling: touch;
    section {
      width: 100%;
      height: 100%;
      overflow: auto;
    }
  }
</style>
